import { memo } from "react";

import InsuranceIcon from "../../../../../public/BP_resources/images/icon/insurance-icon-color.svg";
import PlaceHolderifNothingAdded from "../../../components-new-final/placeholder-nothing-added";

import InsuranceCard from "./insuranceCard";

const InsuranceList = memo(
  ({
    insurances,
    billData,
    onEditInsurance,
    onExtractInsuranceData,
    name,
    avatar,
    setShowInsuranceModal,
  }) => {
    if (!insurances?.length) {
      return <EmptyState setShowInsuranceModal={setShowInsuranceModal} />;
    }
    return (
      <div>
        {insurances?.map((insurance) => (
          <InsuranceCard
            key={insurance.id}
            insurance={insurance}
            billData={billData}
            onEdit={onEditInsurance}
            onExtractData={onExtractInsuranceData}
            name={name}
            avatar={avatar}
          />
        ))}
      </div>
    );
  }
);

const EmptyState = ({ setShowInsuranceModal }) => (
  <PlaceHolderifNothingAdded
    text1={"No Client Insurance Added"}
    text2={"Click to Add"}
    pageIcon={InsuranceIcon}
    onClick={() => setShowInsuranceModal(true)}
  />
);

export default InsuranceList;
